




















































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchReasignacionEquipos } from './fetchReasignacionEquipos';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class ModalCrearReasignacion extends Vue {
  @Prop({ default: false }) coordinadores!: any;
  @Prop({ default: false }) tecnicos!: any;
  @Prop({ default: false }) usuarioActivo!: any;
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReasignacionEquipos;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';

  sim: any = [];
  tipoeq: any = [];
  serieNum: any = [];
  formFields: FormFieldDefMap = {
    tecnico: {
      label: 'Técnico',
      id: 'tecnicoid',
      value: '',
    },
    coordinador: {
      label: 'Coordinador',
      id: 'coorid',
      value: '',
    },
    NDV: {
      label: 'Nota de Venta',
      id: '',
      value: '',
    },
    EPC: {
      label: 'EPC',
      id: '',
      value: '',
    },
    fundamento: {
      label: 'Motivo',
      id: '',
      value: '',
    },
    tEquipo: {
      label: 'Tipo de Equipo',
      id: 'tequipoid',
      value: '',
    },
    serie: {
      label: 'Serie',
      id: '',
      value: '',
    },
    sim: {
      label: 'SIM',
      id: '',
      value: '',
    },
  };
  datoNuevo: any = {};
  crear() {
    let self = this;
    if (
      this.formFields.coordinador.value == '' ||
      this.formFields.coordinador.value == null
    ) {
      self.$snotify.error('Coordinador no puede estar vacío', {
        timeout: 3000,
      });
    } else if (
      this.formFields.NDV.value == '' ||
      this.formFields.NDV.value == null
    ) {
      self.$snotify.error('Nota de Venta no puede estar vacío', {
        timeout: 3000,
      });
    } else if (
      this.formFields.fundamento.value == '' ||
      this.formFields.fundamento.value == null
    ) {
      self.$snotify.error('Motivo no puede estar vacío', { timeout: 3000 });
    } else if (
      this.formFields.tecnico.value == '' ||
      this.formFields.tecnico.value == null
    ) {
      self.$snotify.error('Técnico no puede estar vacío', { timeout: 3000 });
    } else if (
      this.formFields.serie.value == '' ||
      this.formFields.serie.value == null
    ) {
      self.$snotify.error('Serie no puede estar vacío', { timeout: 3000 });
    } else if (
      this.formFields.tEquipo.value == '' ||
      this.formFields.tEquipo.value == null
    ) {
      self.$snotify.error('Tipo de Equipo no puede estar vacío', {
        timeout: 3000,
      });
    } else {
      this.datoNuevo = {
        usuario: this.usuarioActivo[0].id,
        rut: this.usuarioActivo[0].rut,
        coordinador: this.formFields.coordinador.value,
        notaventa: this.formFields.NDV.value,
        epc: this.formFields.EPC.value,
        motivo: this.formFields.fundamento.value,
        tecnico: this.formFields.tecnico.value,
        serie: this.formFields.serie.value,
        tipoEquipo: this.formFields.tEquipo.value,
        sim: this.formFields.sim.value ? this.formFields.sim.value : null,
      };
      this.crearRea();
    }
  }

  crearRea() {
    let self = this;
    this.loadingService.showLoading();
    if (
      this.datoNuevo.coordinador != '' &&
      this.datoNuevo.notaventa != '' &&
      this.datoNuevo.motivo != '' &&
      this.datoNuevo.tecnico != '' &&
      this.datoNuevo.serie != '' &&
      this.datoNuevo.tipoEquipo != ''
    ) {
      return fetchReasignacionEquipos(
        {
          usuario: this.datoNuevo.usuario,
          rut: this.datoNuevo.rut,
          coordinador: this.datoNuevo.coordinador,
          notaventa: this.datoNuevo.notaventa,
          epc: this.datoNuevo.epc,
          motivo: this.datoNuevo.motivo,
          tecnico: this.datoNuevo.tecnico,
          tipoequipo: this.datoNuevo.tipoEquipo,
          serienumero: this.datoNuevo.serie,
          simserienumero: this.datoNuevo.sim,
        },
        'conectaReasignacion/crear'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
            this.closeModal(false);
            this.loadingService.hideLoading();
            return null;
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
            this.loadingService.hideLoading();
            return null;
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Error al crear el despacho', { timeout: 3000 });
        });
      /*.finally(() => {
        return null;
      });  */
    } else {
      self.$snotify.error('Por favor ingrese todos los campos obligatorios', {
        timeout: 3000,
      });
    }
  }

  loadnumeroSerie() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReasignacionEquipos(
      {
        tecnico: this.formFields.tecnico.value,
      },
      'conectaReasignacion/loadNumeroSerie'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.serieNum = data.data.SERIE;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  loadDatos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReasignacionEquipos(
      {
        serienumero: this.formFields.serie.value,
      },
      'conectaReasignacion/loadDatosReasignacion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.tipoeq = data.data.TIPOEQ;
          this.sim = data.data.SIM;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.$emit('datoCreado', true);
    this.$emit('modalAsociacionEmit', false);
    //Reset Validaciones
    this.dialog = false;
  }
  mounted() {}
}
